import { Box, Button, Chip, Dialog, DialogActions, DialogContent, Grid, IconButton, Paper, Stack, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { CloseLineIcon, EmailIcon, LocationIcon, PhoneIcon, UserIcon } from '../../components/IconComponent'
import { useTranslation } from 'react-i18next';
import { emptyStringIfNull } from '../../utils/util'
import { Field, Form } from 'react-final-form'
import { TextFieldCustom } from '../../components/FormElements';
import ScheduleDateNotesView from './ScheduleDateNotesView';

export default function SwapDeviceDetailView(props) {
    const { activity, device, device2, files, isSelfScheduleingUser, setChangeRemoveDevice, setChangeAddDevice, onRemoveDevice, validate, setValidate } = props;
    const { t } = useTranslation();
    const { palette } = useTheme();
    const [note, setNote] = useState(null);

    const renderState = (type, state) => {
        let label = t(state);
        let color = null;
        switch (type) {
            case "activity":
                color = (state == 'PENDING' ? 'warning' : 'success');
                break;
            case "device":
                color = 'info';
                break;
        }

        return <Chip label={label} variant='customOutlined' size='small' color={color} />
    }

    return (
        <Form
            onSubmit={() => props.onSubmit(note)}
            render={({ handleSubmit, form }) => (
                <form onSubmit={handleSubmit}>

                    <Dialog
                        open={props.isOpen}
                        onClose={props.onClose}
                        fullWidth={true}
                        maxWidth={"md"}
                        sx={{ '& .MuiDialog-paper': { padding: '0px 0px' } }}
                    >
                        <Stack width={'100%'} height={60} flexDirection={'row'} justifyContent={'flex-start'} alignItems={'center'} paddingX={2}>
                            <IconButton onClick={() => props.onClose()}>
                                <CloseLineIcon />
                            </IconButton>
                            <Typography variant='body1' marginLeft={1} marginRight={1}>{"Activity"} {activity.custom_fields.find(field => field.key === 'activity_number')?.value} {activity.name}</Typography>
                            <Chip label={activity.type.name} variant='customOutlined' size='small' sx={{ backgroundColor: activity.type.colour, color: "#FFFFFF", marginRight: 1 }} />
                            {renderState("activity", activity.states[0].state)}
                            {activity.custom_fields.find(field => field.key === 'status') && <Chip label={activity.custom_fields.find(field => field.key === 'status').value} variant='customOutlined' size='small' sx={{ marginLeft: 1 }} />}
                        </Stack>
                        <DialogContent dividers={true} sx={{
                            padding: '0px 0px'
                        }}>
                            <Grid xs={12} item container direction={'row'} spacing={2} paddingX={2} paddingY={2}>
                                <Grid xs={12} md={6} item>
                                    <Grid xs={12} item component={Paper} paddingX={2} paddingY={2}>
                                        <Stack flex={1} direction={'row'} spacing={1}>
                                            <UserIcon />
                                            <Stack>
                                                <Typography variant='subtitle2'>{activity.contact.company_name ? activity.contact.company_name : activity.contact.person_name.full_name}</Typography>
                                                <Typography variant='subtitle1' sx={{
                                                    border: '1px solid',
                                                    borderColor: palette.border.main,
                                                    paddingX: 0.5,
                                                    paddingY: 0,
                                                    fontSize: 12,
                                                    borderRadius: 1
                                                }}>{activity.contact.code}</Typography>
                                            </Stack>
                                        </Stack>
                                        {activity.contact.email_address && <Stack flex={1} direction={'row'} spacing={1} marginTop={1}>
                                            <EmailIcon />
                                            <Typography variant='subtitle2'>{activity.contact.email_address}</Typography>
                                        </Stack>}
                                        {activity.contact.phone && <Stack flex={1} direction={'row'} spacing={1} marginTop={1}>
                                            <PhoneIcon />
                                            <Typography variant='subtitle2'>{activity.contact.phone.number}</Typography>
                                        </Stack>}
                                        {activity.contact && activity.contact.addresses && activity.contact.addresses.length > 0
                                            && <Stack flex={1} direction={'row'} spacing={1} mt={1}>
                                                <LocationIcon />
                                                <Typography variant='subtitle2'>{activity.contact.addresses[0].address_line_1 +
                                                    emptyStringIfNull(activity.contact.addresses[0].address_line_2) +
                                                    emptyStringIfNull(activity.contact.addresses[0].state_province_county) +
                                                    emptyStringIfNull(activity.contact.addresses[0].town_city) +
                                                    emptyStringIfNull(activity.contact.addresses[0].postal_code)}
                                                </Typography>
                                            </Stack>}
                                    </Grid>
                                    <Grid xs={12} item component={Paper} paddingX={2} paddingY={2} marginTop={2}>
                                        <Field
                                            name="removedSerial"
                                            component={TextFieldCustom}
                                            label={t('device_removed')}
                                            placeholder={t('enter_removed_device')}
                                            onCustomChange={(e) => {
                                                let check = 0
                                                if (check == 0 && e != "") {
                                                    setValidate((prev) => ({ ...prev, remove: false }))
                                                    check = 1
                                                }
                                                setChangeRemoveDevice(e)
                                            }
                                            }
                                            isEdit={true}
                                            color='default'
                                            autoFocus={true}
                                            validatez={validate.remove}
                                        />
                                        <Box sx={{ mt: "20px" }} > </Box>
                                        <Field
                                            name="addedSerial"
                                            component={TextFieldCustom}
                                            label={t('device_added')}
                                            placeholder={t('enter_added_device')}
                                            onCustomChange={(e) => {
                                                let check = 0
                                                if (check == 0 && e != "") {
                                                    setValidate((prev) => ({ ...prev, add: false }))
                                                    check = 1
                                                }
                                                setChangeAddDevice(e)
                                            }
                                            }
                                            isEdit={true}
                                            color='default'
                                            // validate={validators.composeValidators(validators.required)}
                                            autoFocus={true}
                                            validatez={validate.add}
                                        />
                                        <Box sx={{ mt: "10px", display: "flex", justifyContent: "end" }} >
                                            <Button variant='contained' onClick={() => onRemoveDevice(form)}  >{t('perform_swap')}</Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid xs={12} md={6} item>
                                    <ScheduleDateNotesView {...props} setNote={setNote} />
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Grid xs={12} item container direction={'row'} paddingX={2} paddingY={1} justifyContent={'center'}>
                                <Button sx={{ marginRight: 2 }} variant='contained' onClick={handleSubmit} type='submit'>{t('submit')}</Button>
                            </Grid>
                        </DialogActions>
                    </Dialog>
                </form>)}
        />
    )
}
